<template>
  <form class="my-3">

    <b-row v-if="invoiceToEditId.length > 0" class="text-uppercase mb-3">
      <b-col cols="6" class="text-left">
        <h5 class="text-dark font-weight-bold">
          {{$t($getConst.pages.invoice_details.invoice_id)}}:
          <b-skeleton width="5rem" height="20px !important" class="mb-2 d-inline-flex" v-if="is_loading"></b-skeleton>
          <span v-else class="font-weight-light">
            {{invoice.vms_id}}
          </span>
        </h5>
      </b-col>
    </b-row>

    <b-list-group class="text-capitalize mb-4">

      <!--   Timesheet inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.invoice_details.invoice_timesheet_section_title)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.timesheets"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="vms_timesheet_id"
                          :label="$t($getConst.pages.invoice_details.invoice_timesheet_id)"
                          label-for="vms_timesheet_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vms_timesheet_id-input"
                            v-model.trim="invoice.vms_timesheet_id"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vms_timesheet_id)"
                            size="lg"
                            required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="worker_full_name" :label="$t($getConst.pages.invoice.worker_full_name)"
                          label-for="worker_full_name-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="worker_full_name-input"
                            v-model.trim="$v.invoice.worker_full_name.$model"
                            :class="{ 'is-invalid': $v.invoice.worker_full_name.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_worker_full_name)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.worker_full_name"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>


      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row class="pb-2">
          <b-col cols="6">
            <b-form-group id="timesheet_hours"
                          :label="$t($getConst.pages.invoice_details.invoice_timesheet_hours)"
                          label-for="timesheet_hours-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="timesheet_hours-input"
                            v-model.trim="$v.invoice.timesheet_hours.$model"
                            :class="{ 'is-invalid': $v.invoice.timesheet_hours.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_timesheet_hours)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.timesheet_hours"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="timesheet_end_date"
                          :label="$t($getConst.pages.invoice_details.invoice_timesheet_end_date)"
                          label-for="timesheet_end_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="timesheet_end_date-input"
                                 v-model.trim="$v.invoice.timesheet_end_date.$model"
                                 :class="{ 'is-invalid': $v.invoice.timesheet_end_date.$error }"
                                 :placeholder="$t(this.$getConst.pages.invoice.enter_timesheet_end_date)"
                                 :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"

                                 size="lg"
                                 required
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.invoice.timesheet_end_date"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <!--   Vendor inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.invoice_details.invoice_vendor_section_title)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.vendor"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row class="pb-2">
          <b-col cols="6">

            <b-form-group id="vendor_gp_id" :label="$t($getConst.pages.invoice.vendor_gp_id)"
                          label-for="vendor_gp_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vendor_gp_id-input"
                            v-model.trim="$v.invoice.vendor_gp_id.$model"
                            :class="{ 'is-invalid': $v.invoice.vendor_gp_id.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vendor_gp_id)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.vendor_gp_id"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="vendor_name" :label="$t($getConst.pages.invoice.vendor_name)"
                          label-for="vendor_name-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vendor_name-input"
                            v-model.trim="$v.invoice.vendor_name.$model"
                            :class="{ 'is-invalid': $v.invoice.vendor_name.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vendor_name)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.vendor_name"/>
            </b-form-group>

          </b-col>
        </b-row>
      </b-list-group-item>

      <!--   Assignments inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.invoice_details.invoice_assignment_section_title)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.job"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="vms_assignment_id" :label="$t($getConst.pages.invoice_details.invoice_assignment_id)"
                          label-for="vms_assignment_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vms_assignment_id-input"
                            v-model.trim="$v.invoice.vms_assignment_id.$model"
                            :class="{ 'is-invalid': $v.invoice.vms_assignment_id.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vms_assignment_id)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.vms_assignment_id"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="assignment_bill_rate" :label="$t($getConst.pages.invoice.assignment_bill_rate)"
                          label-for="assignment_bill_rate-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="assignment_bill_rate-input"
                            v-model.trim="$v.invoice.assignment_bill_rate.$model"
                            :class="{ 'is-invalid': $v.invoice.assignment_bill_rate.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_assignment_bill_rate)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.assignment_bill_rate"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row class="pb-2">
          <b-col cols="6">
            <b-form-group id="assignment_purchase_rate"
                          :label="$t($getConst.pages.invoice.assignment_purchase_rate)"
                          label-for="assignment_purchase_rate-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="assignment_purchase_rate-input"
                            v-model.trim="$v.invoice.assignment_purchase_rate.$model"
                            :class="{ 'is-invalid': $v.invoice.assignment_purchase_rate.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_assignment_purchase_rate)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.assignment_purchase_rate"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <!--   Payment inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.invoice_details.invoice_payment_section_title)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.invoices"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="vms_id" :label="$t($getConst.pages.invoice.vms_id)" label-for="vms_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vms_id-input"
                            v-model.trim="$v.invoice.vms_id.$model"
                            :class="{ 'is-invalid': $v.invoice.vms_id.$error || invoiceExist }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vms_id)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.vms_id"/>
              <b-form-invalid-feedback v-if="invoiceExist">
                {{$t(this.$getConst.pages.form.exist_field_error)}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="issued_date" :label="$t($getConst.pages.invoice.issued_date)"
                          label-for="issued_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="issued_date-input"
                                 v-model.trim="$v.invoice.issued_date.$model"
                                 :class="{ 'is-invalid': $v.invoice.issued_date.$error }"
                                 :placeholder="$t(this.$getConst.pages.invoice.enter_issued_date)"
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 size="lg"
                                 required
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.invoice.issued_date"/>
            </b-form-group>
          </b-col>
        </b-row>

      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="due_date" :label="$t($getConst.pages.invoice.due_date)"
                          label-for="due_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="due_date-input"
                                 v-model.trim="$v.invoice.due_date.$model"
                                 :class="{ 'is-invalid': $v.invoice.due_date.$error }"
                                 :placeholder="$t(this.$getConst.pages.invoice.enter_due_date)"
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 size="lg"
                                 required
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.invoice.due_date"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="payment_status" :label="$t($getConst.pages.invoice.payment_status)"
                          label-for="payment_status-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="payment_status-input"
                            v-model.trim="$v.invoice.payment_status.$model"
                            :class="{ 'is-invalid': $v.invoice.payment_status.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_payment_status)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.payment_status"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="currency" :label="$t($getConst.pages.invoice.currency)"
                          label-for="currency-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="currency-input"
                            v-model.trim="$v.invoice.currency.$model"
                            :class="{ 'is-invalid': $v.invoice.currency.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_currency)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.currency"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="msp_fee" :label="$t($getConst.pages.invoice.msp_fee)"
                          label-for="msp_fee-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="msp_fee-input"
                            v-model.trim="$v.invoice.msp_fee.$model"
                            :class="{ 'is-invalid': $v.invoice.msp_fee.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_msp_fee)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.msp_fee"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="vms_fee" :label="$t($getConst.pages.invoice.vms_fee)"
                          label-for="vms_fee-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="vms_fee-input"
                            v-model.trim="$v.invoice.vms_fee.$model"
                            :class="{ 'is-invalid': $v.invoice.vms_fee.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_vms_fee)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.vms_fee"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="amount_supplier" :label="$t($getConst.pages.invoice.amount_supplier)"
                          label-for="amount_supplier-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="amount_supplier-input"
                            v-model.trim="$v.invoice.amount_supplier.$model"
                            :class="{ 'is-invalid': $v.invoice.amount_supplier.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_amount_supplier)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.amount_supplier"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="amount_client" :label="$t($getConst.pages.invoice.amount_client)"
                          label-for="amount_client-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="amount_client-input"
                            v-model.trim="$v.invoice.amount_client.$model"
                            :class="{ 'is-invalid': $v.invoice.amount_client.$error }"
                            :placeholder="$t(this.$getConst.pages.invoice.enter_amount_client)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.invoice.amount_client"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

    <AppConfirmButtons
      :submit-text="$getConst.pages.button.save"
      :cancel-text="$getConst.pages.button.cancel_changes"
      :isLoading="save_is_loading"
      @onSubmit="submit"
      @onCancel="resetData"
    />

  </form>

</template>

<script>
  import {required, decimal, integer} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";
  import {addInvoice, editInvoice, getInvoice} from "../../api/invoices.api";

  const initInvoice = () => {
    return {
      vms_id: '',
      amount_supplier: '',
      amount_client: '',
      msp_fee: '',
      vms_fee: '',
      currency: '',
      worker_full_name: '',
      payment_status: '',
      issued_date: '',
      due_date: '',
      vms_timesheet_id: '',
      timesheet_hours: '',
      timesheet_end_date: '',
      vms_assignment_id: '',
      assignment_bill_rate: '',
      assignment_purchase_rate: '',
      vendor_gp_id: '',
      vendor_name: '',
    }
  };

  export default {
    name: "InvoiceForm",
    components: {AppConfirmButtons, AppFormFeedback},
    props: {
      invoiceToEditId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        invoice: initInvoice(),
        invoiceExist: false,
        is_loading: false,
        save_is_loading: false
      }
    },

    validations: {
      invoice: {
        vms_id: {required},
        amount_supplier: {required, decimal},
        amount_client: {required, decimal},
        msp_fee: {decimal},
        vms_fee: {decimal},
        currency: {required},
        worker_full_name: {required},
        payment_status: {required},
        issued_date: {required},
        due_date: {required},
        timesheet_hours: {required, integer},
        timesheet_end_date: {required},
        vms_assignment_id: {required},
        assignment_bill_rate: {decimal},
        assignment_purchase_rate: {decimal},
        vendor_gp_id: {required},
        vendor_name: {required},
      }
    },

    methods: {
      isFormInvalid() {
        this.$v.$touch();
        return this.$v.$invalid;

      },
      submit() {
        if (this.isFormInvalid()) {
          return;
        }
        this.save_is_loading = true;
        if (this.invoiceToEditId.length === 0) {
          addInvoice(this.invoice).then(
            response => {
              this.$snotify.success(this.$t(this.$getConst.pages.invoice.invoice_added));
              this.save_is_loading = false;
              this.$router.push({name: this.$getConst.routesNames.invoices});
            },
            error => {
              this.handleApiError(error);
              this.save_is_loading = false;
            }
          );
        } else {
          editInvoice(this.invoiceToEditId, this.invoice).then(
            response => {
              this.$snotify.success(this.$t(this.$getConst.pages.invoice.invoice_updated));
              this.save_is_loading = false;
              this.$router.push({name: this.$getConst.routesNames.invoices});
            },
            error => {
              this.handleApiError(error);
              this.save_is_loading = false;
            }
          );
        }
      },
      resetData() {
        if (this.invoiceToEditId.length !== 0) {
          this.getInvoice();
        } else {
          this.invoice = initInvoice();
          this.$v.$reset();
        }
      },
      getInvoice() {
        this.is_loading = true;
        getInvoice(this.invoiceToEditId).then(
          response => {
            this.invoice = response.data;
            this.invoice.timesheet_end_date = this.convertDate(this.invoice.timesheet_end_date);
            this.invoice.issued_date = this.convertDate(this.invoice.issued_date);
            this.invoice.due_date = this.convertDate(this.invoice.due_date);
            this.is_loading = false;
          },
          error => {
            if (error.response.status === 404) {
              this.$snotify.error(this.$getConst.pages.invoice.redirect_to_invoices_page, this.$t(this.$getConst.pages.alerts.unknown_error));
            } else {
              this.handleApiError(error);
            }

            setTimeout(() => {
              this.$router.push({name: this.$getConst.routesNames.invoices});
            }, 5000);

            this.is_loading = false;
          }
        );
      },
      convertDate(date) {
        return date.split('/').reverse().join('-');
      }
    },
    created() {
      if (this.invoiceToEditId.length !== 0) {
        console.log(this.invoiceToEditId);
        this.getInvoice();
      }
    }
  }
</script>

<style scoped>
  .list-group {
    border-radius: 0 !important;
  }

  .list-group-item {
    border-right: none !important;
    border-left: none !important;
  }

  .list-group-section-title {
    border-top: none !important;
  }

  .b-skeleton {
    height: 45px !important;
  }
</style>
